<template>
  <select v-model="childValue" class="custom-select">
    <option value=""></option>
    <option v-for="(l, i) in options" :key="i" :value="l.id">{{l.name}}</option>
  </select>
</template>

<script>
import { AdminService } from "../AdminService";
import { debounce } from "lodash";

// let adminServ = new AdminService();

export default {
  components: {
  },
  props: {
    disabled: {
      default: false
    },
    value: {
      default: undefined
    }
  },
  watch: {
    //
  },
  computed: {
    childValue: {
      get() { return this.value; },
      set (val) { this.$emit('input', val); }
    }
  },
  data() {
    return {
      isLoading: false,
      val: undefined,
      options: []
    };
  },
  created() {
    //
  },
  async mounted () {
    let res = await AdminService.getUsers({ per_page: 1000 });
    this.options = res.data;
  },
  methods: {
    //
  }
};
</script>
